import { render, staticRenderFns } from "./CreateDomaine.vue?vue&type=template&id=6ac8b87f&"
import script from "./CreateDomaine.vue?vue&type=script&lang=js&"
export * from "./CreateDomaine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports